export const categoriesFilter = document.querySelector('.js-categories-filter');

export const categoriesFilterBtn = document.querySelector(
  '.js-categories-filter__btn'
);
export const categoriesFilterIcon = document.querySelector(
  '.js-categories-filter__icon'
);
export const categoriesFilterContainer = document.querySelector(
  '.js-categories-filter__container'
);
export const jsCategoryBtn = document.querySelectorAll('.js-category-btn');

export const searchForm = document.querySelector('.header-form');
export const listNews = document.querySelector('.list-news');
export const notFound = document.querySelector('.not-found');
export const readNewsDateContainer = document.querySelector('.read-date-news');

export const pagList = document.querySelector('.js-pagination');
export const nextPage = document.querySelector('.js-pagination__next-btn');
export const previousPage = document.querySelector(
  '.js-pagination__previous-btn'
);
export const pagListBtn = document.querySelector('.js-pagination__pages-list');
export const pagWrapper = document.querySelector('.pagination__wrapper');

// календарь

export const calendarForm = document.querySelector('calendar-form');
export const daysTag = document.querySelector('.days');
export const currentDate = document.querySelector('.current-date');
export const switchesMonth = document.querySelectorAll('.calendar-icons span');
export const selectedDate = document.getElementById('input-picker');

export const calendar = {
  openModalBtn: document.querySelector('[data-modal-open]'),
  closeModalBtn: document.querySelector('body'),
  modal: document.querySelector('[data-modal]'),
  inputField: document.querySelector('.calendar-input'),
  toggleBtn: document.querySelector('.calendar__button-down'),
  calendarBtn: document.querySelector('.form-container__icon-calendar'),
};
